export default "__VITE_ASSET__BHF89I6z__"